import * as Yup from 'yup'
import type { TabOption } from '../../../../shared/components/FormTabHeader'
import { branches } from '../../../../shared/models/SharedApiLookups';

// models/InsuranceExpenseModel.ts
export interface InsuranceExpenseModel {
    id: string;                 // create’te null

    date: string;               // yyyy-MM-dd
    branch: { id: number | null };

    insuranceType: string;
    policyNumber: number;

    insuranceStartDate: string; // yyyy-MM-dd
    insuranceEndDate: string;   // yyyy-MM-dd
    amount: number;
    insuranceCompany: string;

    transactor: string;
    vehicleValue: number;
    iMMValue: number;
    accessoryValue: number;
    remainder: number;

    paymentDate: string;       // yyyy-MM-dd
    payment: number;
    paymentType: string;
    cashRegisterCode: string;
    iban: string;
    description: string;

    transactionKm: number;

    endorsmentDate: string;
    endorsmentIssueDate: string;
    endorsmentNo: string;
    endorsmentDescription: string;
    endorsmentype: string;
    endorsmentReason: string;
    endorsmentValue?: string;
    endorsmentGrossPremium: number;
    endorsmentNetPremium: number;
    endorsmentTax: string;
}

export const initialInsuranceExpense: InsuranceExpenseModel = {
    id: '',

    date: '',
    branch: { id: null },
    insuranceType: '',
    policyNumber: 0,

    insuranceStartDate: '',
    insuranceEndDate: '',
    amount: 0,
    insuranceCompany: '',

    transactor: '',
    vehicleValue: 0,
    iMMValue: 0,
    accessoryValue: 0,
    remainder: 0,

    paymentDate: '',
    payment: 0,
    paymentType: '',
    cashRegisterCode: '',
    iban: '',
    description: '',

    transactionKm: 0,

    endorsmentDate: '',
    endorsmentIssueDate: '',
    endorsmentNo: '',
    endorsmentDescription: '',
    endorsmentype: '',
    endorsmentReason: '',
    endorsmentValue: '',
    endorsmentGrossPremium: 0,
    endorsmentNetPremium: 0,
    endorsmentTax: '',
};



export const validationInsuranceExpense = Yup.object({

    insuranceStartDate: Yup.string()
        .required('Başlangıç tarihi zorunlu'),


    insuranceEndDate: Yup.string()
        .required('Bitiş tarihi zorunlu'),


    amount: Yup.number()
        .required('Tutar zorunlu')
})




export const tabOptions: TabOption<
    'bilgi' | 'odeme' | 'arac' | 'zeyil' | 'list'
>[] = [
        { key: 'bilgi', title: 'Bilgi Giriş', icon: 'bi bi-plus-circle' },
        { key: 'odeme', title: 'Ödeme', icon: 'bi bi-credit-card' },
        { key: 'arac', title: 'Araç', icon: 'bi bi-car-front' },
        { key: 'zeyil', title: 'Zeyil', icon: 'bi bi-file-earmark-text' },
        { key: 'list', title: 'İşlem Listesi', icon: 'bi bi-file-earmark-excel' },
    ]

